module.exports = __webpack_public_path__ + "static/media/waterprof.31deaf9b.png";